// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const headerBarClasses = {
  actionBar: "qui-header-bar__action-bar",
  appTitle: "qui-header-bar__app-title",
  divider: "qui-header-bar__divider",
  itemIcon: "qui-header-bar__item-icon",
  itemRoot: "qui-header-bar__item-root",
  logo: "qui-header-bar__logo",
  nav: "qui-header-bar__nav",
  navItem: "qui-header-bar__nav-item",
  root: "qui-header-bar__root",
  windowControls: "qui-header-bar__window-controls",
} as const
